import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';
import { TranslatePipe } from '@ngx-translate/core';
import { IconoirHalfMoon, IconoirSunLight } from '@ey-xd/motif-icon';
import {
  EventService,
  LocalStorageService,
  MainHelperService,
} from '@services/index';
import { APP_EVENT_KEY, THEME } from '@models';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-theme-switch',
  standalone: true,
  imports: [MotifButtonModule, MotifIconModule, TranslatePipe, NgClass],
  templateUrl: './theme-switch.component.html',
  styleUrl: './theme-switch.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitchComponent {
  public readonly lightIcon = IconoirSunLight;
  public readonly darkIcon = IconoirHalfMoon;

  public theme = signal<THEME>(THEME.LIGHT);

  #mainHelperService: MainHelperService = inject(MainHelperService);
  #eventService: EventService = inject(EventService);
  #localStorageService: LocalStorageService = inject(LocalStorageService);

  public toggleTheme(theme: boolean): void {
    this.#eventService.emitEvent(APP_EVENT_KEY.THEME_TOGGLE, theme);
    const themePreference = theme ? THEME.DARK : THEME.LIGHT;
    this.#localStorageService.setItem(
      'themePreference',
      JSON.stringify(themePreference)
    );
  }

  public get isDarkTheme(): boolean {
    return this.#mainHelperService.isDarkTheme();
  }
}
